<div *ngIf="privilegePrintKUL.value || privilegeResetPassword.value" class="d-flex align-items-center position-absolute top-0 end-0 m-9 mt-6">
  <a class="btn btn-outline btn-outline-primary ps-7 mb-2" data-kt-menu-attach="parent" data-kt-menu-placement="bottom-end" data-kt-menu-trigger="click" href="#"
    >Actions
    <span class="svg-icon svg-icon-2 me-0">
      <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M11.4343 12.7344L7.25 8.55005C6.83579 8.13583 6.16421 8.13584 5.75 8.55005C5.33579 8.96426 5.33579 9.63583 5.75 10.05L11.2929 15.5929C11.6834 15.9835 12.3166 15.9835 12.7071 15.5929L18.25 10.05C18.6642 9.63584 18.6642 8.96426 18.25 8.55005C17.8358 8.13584 17.1642 8.13584 16.75 8.55005L12.5657 12.7344C12.2533 13.0468 11.7467 13.0468 11.4343 12.7344Z"
          fill="currentColor"
        />
      </svg>
    </span>
  </a>
  <div class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-semibold py-4 w-300px fs-6" data-kt-menu="true">
    <div *ngIf="privilegeResetPassword" class="menu-item px-5">
      <a (click)="onClickResetPassword()" *ngIf="privilegeResetPassword.value" class="menu-link" mat-menu-item>
        <span class="svg-icon me-4" inlineSVG="{{ STRING_CONSTANTS.ICON.IC_RESET_PASSWORD }}"></span>Reset Password
      </a>
    </div>
  </div>
</div>

<div class="d-flex align-items-center mb-7">
  <span (click)="handleBack()" class="svg-icon svg-icon-2 me-3 cursor-pointer" inlineSVG="./assets/media/icons/ic_arrow_line_left.svg"></span>
  <h1 class="mb-0">Riwayat Produk Eksklusif</h1>
</div>

<ng-container *ngIf="!string_filter && baseDatasource.isTableLoaded && baseDatasource.totalItem$.getValue() === 0; else elseBlock" cardBody>
  <app-card-empty icon="{{ iconNone }}" text="Belum terdapat riwayat produk eksklusif."></app-card-empty>
</ng-container>

<ng-template #elseBlock>
  <app-card [cardBodyClasses]="'pt-2'" [header]="true">
    <ng-container cardHeader>
      <app-input-search
        (actionFilter)="onSearch($event)"
        [isFinishLoadingSubject]="baseDatasource.isFinishLoadingSubject"
        [placeholder]="'Cari Nama Varian Produk'"
        [value]="string_filter"
      ></app-input-search>
    </ng-container>

    <ng-container cardBody>
      <ng-container *ngIf="string_filter && baseDatasource.isTableLoaded && baseDatasource.totalItem$.getValue() === 0; else elseFilterBlock" cardBody>
        <app-card-empty icon="{{ iconNone }}" text="Belum terdapat data product variant."></app-card-empty>
      </ng-container>
      <ng-template #elseFilterBlock>
        <div class="table-responsive">
          <table [dataSource]="baseDatasource" class="table w-100 gy-5 table-row-bordered align-middle" mat-table matSort>
            <ng-container *ngFor="let tableColumn of tableColumns; index as i" [matColumnDef]="tableColumn.key">
              <ng-container *ngIf="tableColumn.isSortable; else notSortTable">
                <th
                  *matHeaderCellDef
                  [arrowPosition]="'after'"
                  [class.min-w-200px]="tableColumn.key !== 'actions' && tableColumn.key !== 'id'"
                  [mat-sort-header]="tableColumn.key"
                  class="min-w-125px px-3"
                  mat-header-cell
                >
                  <div *ngIf="baseDatasource.isFinishLoadingSubject.value">
                    {{ tableColumn.title }}
                  </div>
                  <div *ngIf="!baseDatasource.isFinishLoadingSubject.value">
                    <app-table-content [width]="70"></app-table-content>
                  </div>
                </th>
              </ng-container>
              <ng-template #notSortTable>
                <th
                  *matHeaderCellDef
                  [class.min-w-200px]="tableColumn.key !== 'actions' && tableColumn.key !== 'id'"
                  [ngClass]="{
                    'min-w-70px text-center': tableColumn.key === 'actions',
                    'w-250px': tableColumn.key === 'alamat'
                  }"
                  class="min-w-125px px-3"
                  mat-header-cell
                >
                  <div *ngIf="tableColumn.key === 'available_stock'" class="d-flex info-header-detail-products">
                    <div *ngIf="baseDatasource.isFinishLoadingSubject.value">
                      {{ tableColumn.title }}
                    </div>
                    <div *ngIf="!baseDatasource.isFinishLoadingSubject.value">
                      <app-table-content [width]="180"></app-table-content>
                    </div>
                    <span
                      *ngIf="baseDatasource.isFinishLoadingSubject.value"
                      [inlineSVG]="iconInfo"
                      class="ms-2 cursor-pointer"
                      ngbPopover="Jumlah stok yang tersedia untuk diorder"
                      placement="bottom"
                      popoverClass="tooltip-info-product text-primary"
                    ></span>
                  </div>
                  <div *ngIf="baseDatasource.isFinishLoadingSubject.value && tableColumn.key !== 'available_stock'">
                    {{ tableColumn.title }}
                  </div>
                  <div *ngIf="!baseDatasource.isFinishLoadingSubject.value && tableColumn.key !== 'available_stock'">
                    <app-table-content [width]="180"></app-table-content>
                  </div>
                </th>
              </ng-template>
              <td *matCellDef="let element" class="px-3" mat-cell>
                <ng-container [ngSwitch]="tableColumn.key">
                  <div *ngSwitchCase="'actions'" class="text-center">
                    <button
                      [ngClass]="{
                        'is-download': element['is_download']
                      }"
                      class="btn btn-table-actions-download"
                    >
                      <app-table-content [isFinishLoadingSubject]="baseDatasource.isFinishLoadingSubject" [type]="'icon'">
                        <span (click)="handleAction(element)" [inlineSVG]="iconAction"></span>
                      </app-table-content>
                    </button>
                  </div>
                  <div *ngSwitchCase="'list_variants'">
                    <app-table-content [isFinishLoadingSubject]="baseDatasource.isFinishLoadingSubject">
                      <div style="gap: 10px">
                        <span class="product-list">{{ setVariantItem(element[tableColumn.key])?.name }}</span
                        ><br />
                        <span *ngIf="element[tableColumn.key]?.length > 1" class="desc">+{{ element[tableColumn.key]?.length - 1 }} Varian lainnya</span>
                      </div>
                    </app-table-content>
                  </div>
                  <div *ngSwitchCase="'list_sub_area'">
                    <app-table-content [isFinishLoadingSubject]="baseDatasource.isFinishLoadingSubject">
                      <div class="line-clamp">
                        <span
                          *ngIf="element[tableColumn.key]?.length; else defaultItemText"
                          placement="bottom"
                          popoverClass="tooltip-info-product text-primary"
                          triggers="mouseenter:mouseleave"
                          [ngbPopover]="mapSubAreaObject(element[tableColumn.key])"
                          ><ng-template [ngTemplateOutlet]="defaultItemText"></ng-template
                        ></span>
                        <ng-template #defaultItemText>
                          <span class="text-capitalize">{{ mapSubAreaObject(element[tableColumn.key]) }}</span>
                        </ng-template>
                      </div>
                    </app-table-content>
                  </div>
                  <div *ngSwitchCase="'submitted_time'">
                    <app-table-content [count]="2" [isFinishLoadingSubject]="baseDatasource.isFinishLoadingSubject" [type]="'text'">
                      <div>{{ utilities.timeStampToDate(element['submitted_time'], 'dd-MM-yyyy') }}</div>
                      <div>{{ utilities.timeStampToDate(element['submitted_time'], 'HH:mm:ss') }}</div>
                    </app-table-content>
                  </div>
                  <div *ngSwitchDefault>
                    <app-table-content [isFinishLoadingSubject]="baseDatasource.isFinishLoadingSubject">
                      <span>{{ element[tableColumn.key] ?? '-' }} </span>
                    </app-table-content>
                  </div>
                </ng-container>
              </td>
            </ng-container>

            <tr *matHeaderRowDef="displayedColumns" class="fw-bold text-start text-uppercase" mat-header-row></tr>
            <tr *matRowDef="let row; columns: displayedColumns" mat-row></tr>
          </table>
        </div>
        <div class="d-flex justify-content-between py-4">
          <app-mai-material-bottom-table
            (changePage)="changePageEvent($event)"
            [baseDataTableComponent]="baseDatasource"
            [isFinishLoadingSubject]="baseDatasource.isFinishLoadingSubject"
            class="w-100"
          ></app-mai-material-bottom-table>
        </div>
      </ng-template>
    </ng-container>
  </app-card>
</ng-template>

<app-modal-detail-with-image #modalDetail [detailModal]="detailProductExclusiveData" [isLoading]="isLoading"> </app-modal-detail-with-image>
